<template>
  <div class="smsc-container">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="filters-container flex flex-wrap items-center justify-start pb-3">
          <div class="mt-3 mr-3" style="min-width: 200px">
            <label class="vs-input--label">From</label>
            <div>
              <flat-pickr
                class="w-100"
                :config="{
                  ...configdateTimePicker,
                  dateFormat:  'm-d-Y H:i:s',
                  defaultDate: new Date().setHours(0, 0, 0),
                }"
                v-model="started_at_gt"
                @input="SetDatetimeForStart"
              />
            </div>
          </div>
          <div class="mt-3 mr-3" style="min-width: 200px">
            <label class="vs-input--label">To</label>
            <div>
              <flat-pickr
                 class="w-100"
                :config="{
                ...configdateTimePicker,
                  dateFormat:  'm-d-Y H:i:s',
                  defaultDate: new Date().setHours(23, 59, 59),
                }"
                v-model="finished_at_lt"
                @input="SetDatetimeForEnd"
              />
            </div>
          </div>
          <div class="form-group has-search">
            <span class="fa fa-search form-control-invoice-feedback"></span>
            <input
              @input="onQuickFilterChanged()"
              id="quickFilter"
              v-model="searchProduct"
              class="filter_input_invoice form-control-invoice"
              >
          </div>
        </div>
        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
        </div>
      </div>
    </vx-card>
    <vx-card>
      <!-- Per Page -->
      <div class="mb-4 md:mb-0">
        <per-page
          :currentPerPage="per_page"
          :pageStart="pageStart"
          :pageEnd="pageEnd"
          :total="total"
          @change-per-page="ChangePerPage($event)"
        />
      </div>
      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @filterChanged="Filtering"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :editable="true"
        >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page"
         />
    </vx-card>
  </div>
</template>

<script>
// Mixins
import TableMixin from '@/mixins/table.js'
import DateTimeMixin from '@/mixins/datetime.js'

// Packages
import { format } from 'date-fns'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

// Cell Renderer components
import CellRendererActions from './cell-renderer/CellRendererActions'

// Utils
import { Capitalize } from '@/assets/utils/utils.js'

export default {
  mixins: [TableMixin, DateTimeMixin],
  components: {
    AgGridVue,
    flatPickr,
    CellRendererActions
  },
  data() {
    return {
      // Datetime binding value
      started_at_gt:  new Date().setHours(0, 0, 0),
      finished_at_lt:  new Date().setHours(23, 59, 59),
      searchProduct: '',
      // table header value
      columnDefs: [
        {
          headerName: 'Bulk UUID',
          field: 'bulk_uuid',
          minWidth: 400,
          sortable: 'bulk_uuid',
          unSortIcon: true,
          resizing: true
        },
        {
          headerName: 'Created On',
          field: 'started_at',
          sortable: 'started_at',
          unSortIcon: true,
          minWidth: 200,
        },
        {
          headerName: 'Status',
          field: 'status',
          sortable: 'status',
          unSortIcon: true,
          minWidth: 200,
        },
        {
          headerName: 'Count',
          field: 'dest_count',
          minWidth: 200,
        },
        {
          headerName: 'Sent',
          field: 'dest_sent',
          minWidth: 200,
        },
        {
          headerName: 'Failed',
          field: 'route_status_sending_failed_count',
          minWidth: 200,
        },
        {
          headerName: 'Success',
          field: 'route_status_sent_to_vendor_count',
          minWidth: 200,
        },
        {
          headerName: 'Rejected',
          field: 'route_status_rejected_count',

          minWidth: 220,
        },
        {
          headerName: 'Text',
          field: 'text',
          sortable: 'text',
          unSortIcon: true,
          minWidth: 240,
          filter: true
        },
        {
          headerName: 'Action',
          cellRendererFramework: 'CellRendererActions',
          minWidth: 200,
        }
      ],

      // Cell Renderer components
      components: {
        CellRendererActions
      }
    }
  },
  created(){
    this.filters.started_at_gt =  new Date(this.started_at_gt)
    this.filters.finished_at_lt = new Date(this.finished_at_lt)
    this.GetList()
  },
  methods: {
    SetDatetimeForEnd() {
      this.filters.finished_at_lt = new Date(this.finished_at_lt)
      this.GetList()
    },
    SetDatetimeForStart() {
      this.filters.started_at_gt = new Date(this.started_at_gt)
      this.GetList()
    },
    GetList () {
      this.$vs.loading()
      this.$store.dispatch('bulk/GetList', {
        ...this.filters,
        page: this.page || 0,
        per_page: this.per_page || 10,
        order_by: this.order_by || null,
        order_dir: this.order_dir || 'desc',
        bulk_uuid: this.searchProduct + '*'
      })
      .then(res => {
        this.list = res.items.map(this.TransformList)
        this.total = res.total
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
    },


    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },

    // Transform functions
    TransformList(item) {
      return {
        refreshData: this.GetList,
        bulk_uuid: item.bulk_uuid,
        started_at: item.started_at ? format(new Date(item.started_at), 'yyyy-MM-dd HH:mm:ss') : null,
        status: Capitalize(item.status),
        dest_count: item.dest_count,
        dest_sent: item.dest_sent,
        route_status_sending_failed_count: item.route_status_sending_failed_count,
        route_status_sent_to_vendor_count: item.route_status_sent_to_vendor_count,
        route_status_rejected_count: item.route_status_rejected_count,
        text: item.text

      }
    },
    onQuickFilterChanged() {
      this.GetList()
    },
  }
}
</script>
<style>
    .filter_input_invoice{
        padding: 17px;
        padding-left: 55px;
        width: 220px;
        height: 42px;
        border: 1px solid #f5f5f5;
        font-size: 13px;
        color: gray;
        background-repeat: no-repeat;
        background-position: left center;
        outline: 0;
        margin-top: 30px;
    }
    .has-search .form-control-invoice-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 15px;
        height: 15px;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: gray;
        margin-left: 25px;
        margin-top: 44px;
    }
    div.ag-root .ag-cell-focus {
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
    }
</style>
